// Textos del listado de usuarios de marketing (marketing-users). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    MARKETING_USERS: {
      ACTIONS: {
        EXPORT_CSV: 'Exportar CSV',
        SOON: 'Pronto',
        RELOAD: 'Recargar',
        LOADING: 'Cargando...',
        RETRY: 'Reintentar',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        FIRST_PAGE: 'Primera página',
        LAST_PAGE: 'Última página',
        DONE: 'Hecho',
        CLOSE: 'Cerrar',
        CLEAR: 'Limpiar',
        APPLY: 'Aplicar',
        CLEAR_ALL: 'Borrar todos',
        REMOVE_FILTER: 'Quitar {{label}}',
        CLEAR_SEARCH: 'Borrar búsqueda',
      },
      FUNNEL: {
        ARIA: 'Embudo de usuarios',
        FILTERED_BY: 'Datos filtrados por:',
        LOADING_SUMMARY: 'Cargando resumen',
        REGISTERED: 'Registrados',
        VERIFIED: 'Verificados',
        WITH_ROUTINE: 'Con rutina de pooling',
        WITH_FINISHED_ROUTES: 'Con rutas finalizadas',
        CONV_TOOLTIP: 'Sobre el total de registrados',
        CAE_NOTE: 'con CAE activo · {{pct}}% del total',
        PERMISSIONS_TITLE: 'Permisos concedidos (de {{total}} registrados)',
      },
      PERMISSIONS: {
        NOTIFICATION: 'Notificaciones',
        LOCATION: 'Ubicación',
        BACKGROUND_LOCATION: 'Ubicación en segundo plano',
        PHYSICAL_ACTIVITY: 'Actividad física',
        BLUETOOTH: 'Bluetooth',
      },
      VIEWS: {
        ARIA: 'Vista',
        ALL: 'Todos',
        VERIFIED: 'Verificados',
        CAE: 'CAE activo',
        ROUTINE: 'Con rutina de pooling',
      },
      PANEL: {
        DEFAULT_TITLE: 'Usuarios',
        ALL_TITLE: 'Todos los usuarios',
        ALL_SUBTITLE: 'Busca, filtra y elige qué columnas ver. Pulsa un nombre para abrir su ficha.',
        VERIFIED_TITLE: 'Usuarios verificados',
        VERIFIED_SUBTITLE: 'Usuarios que han completado la verificación.',
        CAE_TITLE: 'Usuarios con CAE activo',
        CAE_SUBTITLE: 'Usuarios con el CAE activado.',
        ROUTINE_TITLE: 'Usuarios con rutina de pooling',
        ROUTINE_SUBTITLE: 'Usuarios que tienen al menos una rutina de pooling.',
      },
      SEARCH: {
        PLACEHOLDER: 'Buscar por nombre, apellidos, email o teléfono',
        ARIA: 'Buscar usuarios',
      },
      FILTERS: {
        TITLE: 'Filtros avanzados',
        VERIFIED: 'Verificado',
        CAE_ACTIVE: 'CAE activo',
        WITH_ROUTINE: 'Con rutina de pooling',
        MIN_FINISHED: 'Mín. rutas finalizadas',
        MIN_FINISHED_PLACEHOLDER: 'Ej. 5',
        ROUTE_STATUS: 'Estado de ruta de pooling',
        DATE_FROM: 'Fecha de alta desde',
        DATE_TO: 'Fecha de alta hasta',
        DATE_ERROR: 'Revisa las fechas: deben ser válidas y "Hasta" igual o posterior a "Desde".',
        ALL: 'Todos',
        YES: 'Sí',
        NO: 'No',
        ROUTE_VERIFIED: 'Verificada',
        ROUTE_REJECTED: 'Rechazada',
      },
      CHIPS: {
        VERIFIED: 'Verificado: {{value}}',
        CAE_ACTIVE: 'CAE activo: {{value}}',
        WITH_ROUTINE: 'Con rutina: {{value}}',
        MIN_FINISHED: 'Mín. rutas finalizadas: {{value}}',
        ROUTE_STATUS: 'Estado ruta: {{value}}',
        DATE_FROM: 'Alta desde: {{value}}',
        DATE_TO: 'Alta hasta: {{value}}',
      },
      COLUMNS: {
        EDIT: 'Editar columnas',
        NAME: 'Nombre',
        EMAIL: 'Email',
        PHONE: 'Teléfono',
        VERIFIED: 'Verificado',
        CAE_ACTIVE: 'CAE activo',
        FRAUD: 'Fraude',
        COMPANY: 'Empresa',
        CREATED_AT: 'Fecha alta',
        LAST_ACTIVITY: 'Última actividad',
        GENDER: 'Género',
        BIRTH_DATE: 'Fecha nacimiento',
        STRIPE: 'Stripe',
        ACTIVE_VEHICLE: 'Vehículo activo',
        ADDRESS_HOME: 'Dirección (casa)',
        ADDRESS_WORK: 'Dirección (trabajo)',
        DRIVING_LICENSE: 'Carnet de conducir',
        WELCOME_WHATSAPP: 'WhatsApp bienvenida',
      },
      TABLE: {
        LOADING_ARIA: 'Cargando usuarios de marketing',
        EMPTY: 'No se han encontrado usuarios con los filtros aplicados.',
        LOAD_ERROR: 'No se ha podido cargar el listado de usuarios de marketing.',
        VERIFIED: 'Verificado',
        NOT_VERIFIED: 'Sin verificar',
        YES: 'Sí',
        NO: 'No',
        GENDER_H: 'Hombre',
        GENDER_M: 'Mujer',
        GENDER_O: 'Otro',
        ROWS_PER_PAGE: 'Filas por página',
        ROWS_OPTION: '{{n}} filas',
        SHOWING_ONE: 'Mostrando {{shown}} de {{total}} usuario',
        SHOWING_OTHER: 'Mostrando {{shown}} de {{total}} usuarios',
      },
    },
  },
};
